import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';

import './nextPage.less';

const NextPage = ({ page }) => {
  return (
    <div className={'cdo-nextPage'}>
      <Link to={page.toLowerCase()}>
        <p>{page}</p>
        <Icon type="down" />
      </Link>
    </div>
  );
};

export const NextPageOnlyArrow = () => {
  return (
    <div className={'cdo-nextPage cdo-nextPage-onlyArrow'}>
      <Icon type="down" />
    </div>
  );
};

export default NextPage;
